import {Dossier, StatutFinancement} from '../api/Dossier';
import {ExComissionSeance} from './ex-comission-seance';
import {ExDecision} from './ex-decision';
import {CommissionSeance, CommissionSeanceInterface} from '../api/CommissionSeance';
import {ExDossierExpert} from './ex-dossier-expert';
import {ExUtilisateur} from './ex-utilisateur';
import {Commission, CommissionInterface} from '../api/Commission';
import {DecisionInterface} from '../api/Decision';
import {LienInteretInterface} from '../api/LienInteret';
import {DossierAnnexeInterface} from '../api/DossierAnnexe';


/**
 * @todo : WTF ???? code & code1, label & label1 ?
 */
export class ExDossierStatut {
    public code = 0; //0 - 1 - 2
    public label = 'Non traité';

    /**
     * @deprecated lol
     */
    public code1 = 0; //0 - 1 - 2

    /**
     * @deprecated lol
     */
    public label1 = 'En cours de saisie';
}

export enum StatutValues {
    EnCours = '0',
    ReOuvert = '1',
    Valide = '2',
    Abandon = '10',
    Desiste = '3',
    NonRecevable = '4',
    Expertises = '5',
    Accepte = '6',
    Refuse = '7',
    Attente = '8',
    Complementaire = '9'
}

export enum StatutDossier {
    EnCours = 0,
    ReOuvert = 1,
    Valide = 2,
    Abandon = 10,
    Desiste = 3,
    NonRecevable = 4,
    Expertises = 5,
    Accepte = 6,
    Refuse = 7,
    Attente = 8,
    Complementaire = 9
}


export class ExDossier extends Dossier {

    public montantDemande?;
    public dureeDemandee?;

    public selectedDecision: ExDecision = null;
    public selectedReunion: ExComissionSeance = null;

    public previousDecision: ExDecision = null;
    public previousReunion: ExComissionSeance = null;

    public statutLibelle = '';
    public canWithdraw = true; // Peu se désister
    public canUpdate = false; // Est-ce que l'utilisateur peut modifier son dossier ?
    public aideOpen = false;

    public commissionTableau: CommissionSeance = null;

    public lienInteretsParType: { type: string; libelle: '' }[] = [];
    public calculLiensInteretsPossible = false;

    public dateDerniereAnnexe: Date;

    public monExpertiseClassique?: ExDossierExpert | null;

    constructor(options = null) {
        super();
        if (options) {
            Object.assign(this, options);
            if (this['commissionSeances'] && this['commissionSeances'].length) {
                for (let i = 0; i < this['commissionSeances'].length; i++) {
                    this['commissionSeances'][i] = new ExComissionSeance(
                        this['commissionSeances'][i]
                    );
                }
                this['commissionSeances'] = [
                    ...this['commissionSeances'],
                ] as ExComissionSeance[];
            }

            if (this['decisions'] && this['decisions'].length) {
                for (let i = 0; i < this['decisions'].length; i++) {
                    this['decisions'][i] = new ExDecision(this['decisions'][i]);
                }
                this['decisions'] = [...this['decisions']] as ExDecision[];
            }

            // this.initLastCSorFutureCS();
        }

        if (this.statut == null) {
            this.statut = 0;
        }

        if (this['candidat']) {
            this.candidat = new ExUtilisateur(this.candidat);
        }

        // Statut du dossier Libelle
        this.aideIsOpen();
        this.setStatut(this.statut);

        if (this.dossierExperts && this.dossierExperts.length) {
            for (let i = 0; i < this.dossierExperts.length; i++) {
                this.dossierExperts[i] = new ExDossierExpert(this.dossierExperts[i] as ExDossierExpert);
            }
        }

        if (this.expertisesClassiques) {
            this.expertisesClassiques = this.expertisesClassiques.map(
                e => new ExDossierExpert(e)
            );
        }

        if (this.monExpertiseClassique) {
            this.monExpertiseClassique = new ExDossierExpert(this.monExpertiseClassique);
        }

        this.choixDeLaCommissionPourAfficherDansLesTableaux();
        this.orderCommissionSeance();

        this.lienInteretsParType = this.getLiensInteretsParType();

        this.dateDerniereAnnexe = (this.annexes as (DossierAnnexeInterface | string)[]).reduce(
            (acc, item) => {
                if (typeof item == 'string') {
                    return acc;
                }

                const fichier = item.fichier;
                if (!fichier || typeof fichier == 'string') {
                    return acc;
                }

                if (!acc || acc < fichier.updatedAt) {
                    return fichier.updatedAt;
                }

                return acc;
            },
            null as Date
        );
    }

    // Sert pour la vue Decision
    public setSelectedCSForReunionSpecific(cs: ExComissionSeance) {
        if (cs !== undefined && cs != null) {
            let searchPrevious = '';
            [...this.commissionSeances].map(item => {
                if (item['@id'] === cs['@id']) {
                    this.selectedReunion = new ExComissionSeance(item);
                    this.selectedDecision = this.initDecision(this.selectedReunion);
                    const commissionSelectedReunion = this.selectedReunion.commission as Commission;
                    switch (commissionSelectedReunion.code) {
                        case 'SDEC' :
                            if (this.commissionSeances.find(cse => cse['commission'].code === 'CA')) {
                                searchPrevious = 'CA';
                            } else if (this.commissionSeances.find(cse => cse['commission'].code === 'CS')) {
                                searchPrevious = 'CS';
                            } else {
                                searchPrevious = 'CN';
                            }
                            break;
                        case 'CA' :
                            if (this.commissionSeances.find(cse => cse['commission'].code === 'CS')) {
                                searchPrevious = 'CS';
                            } else {
                                searchPrevious = 'CN';
                            }
                            break;
                        case 'CS' :
                            searchPrevious = 'CN';
                            break;
                    }
                }
            });
            if (searchPrevious !== '') {
                let listPrevious = ([...this.commissionSeances] as CommissionSeanceInterface[]).filter(item =>
                    (new Date(item.datetimeFin) < new Date(this.selectedReunion.datetimeFin)) &&
                    (searchPrevious === 'CN') ?
                        (item.commission.commissionType.code === 'CN' || item.commission.commissionType.code === 'ADHOC') :
                        item.commission.commissionType.code === searchPrevious
                );

                listPrevious = (listPrevious as CommissionSeanceInterface[]).sort((a, b) => (new Date(a.datetimeFin) < new Date(b.datetimeFin)) ? -1 : 1);

                this.previousReunion = new ExComissionSeance(listPrevious[0]);
                this.previousDecision = this.initDecision(this.previousReunion);
            }
        }
    }

    public initDecision(reunion) {
        let decision = null;
        if (!reunion) {
            return new ExDecision();
        }

        [...this.decisions].forEach((item: ExDecision) => {
            if (
                item.commissionSeance['@id'] === reunion['@id']
            ) {
                decision = new ExDecision(item);
            }
        });

        if (decision == null) {
            //Si on pas trouvé de décision on en créer une nouvelle

            //Mettre par defaut les valeurs du candidat.
            decision = new ExDecision();
        }

        return decision;
    }


    // On stock de côté les CN ou les ADHOC

    public choixDeLaCommissionPourAfficherDansLesTableaux(): CommissionSeance {
        let tmp = [...this['commissionSeances']].filter(
            (commi: CommissionSeance) =>
                commi.commission?.commissionType?.code === 'CN' ||
                commi.commission?.commissionType?.code === 'ADHOC'
        );
        // On filtre les CS si on a rien trouvé
        if (tmp.length === 0) {
            tmp = [...this.commissionSeances].filter((commi: CommissionSeance) => commi.commission?.commissionType?.code === 'CS');
        }
        if (tmp.length === 0) {
            return null;
        }
        this.commissionTableau = tmp[0] as CommissionSeance;
        return tmp[0] as CommissionSeance;
    }


    public getCommissionExpertise(): CommissionInterface | null {
        return (this.getCommissionSeanceExpertise())?.commission;
    }

    public getCommissionSeanceExpertise(): CommissionSeanceInterface | null {
        if (!this.commissionSeances) {
            return null;
        }

        return (this.commissionSeances as CommissionSeanceInterface[])
            .find(cs => {
                    const commission = cs.commission;
                    if (!commission || typeof commission === 'string') {
                        return false;
                    }
                    return ['ADHOC', 'CN'].includes(commission?.commissionType?.code);
                }
            );
    }


    // Pour la vue nomination des experts
    public getNextCommissionsByCN() {
        const commissionSeances = [...this.commissionSeances] as ExComissionSeance[];
        return commissionSeances.filter(
            (item: ExComissionSeance) => (
                item.commission['commissionType']['code'].indexOf('CN') !== -1
            )
        );
    }

    /**
     * @deprecated cette fonction porte un nom étrange et reconstruit un valueObject à chaque fois, alors qu'on a déjà
     * des propriétés équivalentes dans cette classe
     */
    public getStatus1(): ExDossierStatut {
        const statut1 = new ExDossierStatut();
        statut1.code1 = this.statut;
        statut1.label1 = 'general.dossier.statut.' + this.statut;
        return statut1;
    }

    /**
     * totalement inutile si setStatut est utilisé pour modifier le statut
     *
     * @deprecated use setStatut() instead
     * @todo : passer statut en readonly
     */
    public applyUpdateStatut() {
        this.setStatut(this.statut);
    }

    public setStatut(statut: number): void {
        this.statut = statut;
        this.statutLibelle = 'general.dossier.statut.' + statut;
        this.calculerDroits();
    }

    public calculerDroits(): void {
        const statutAsString: string = (this.statut != null) ? this.statut.toString() : '0';
        this.aideIsOpen();

        this.canUpdate = this.aideOpen &&
            [
                StatutValues.EnCours as string,
                StatutValues.Abandon as string,
                StatutValues.ReOuvert as string,
                StatutValues.Valide as string
            ].includes(statutAsString) || statutAsString === StatutValues.ReOuvert as string;

        this.canWithdraw = statutAsString !== StatutValues.Abandon && statutAsString !== StatutValues.Desiste && statutAsString !== StatutValues.Refuse && this.statutFinancement !== StatutFinancement.STATUT_FINANCEMENT_CLOTURE;
    }

    public aideIsOpen() {
        if (this.aide != null) {
            if (this.aide['dateDebutSaisie'] != null && this.aide['dateFinSaisie'] != null) {
                const dateDebut = new Date(this.aide['dateDebutSaisie']);
                const dateDuJour = new Date();
                const dateFin = new Date(this.aide['dateFinSaisie']);
                this.aideOpen = (dateFin >= dateDuJour && dateDebut <= dateDuJour);
            } else {
                this.aideOpen = false;
            }
        }
    }

    public orderCommissionSeance() {
        if (this.commissionSeances != null) {
            this.commissionSeances = (this.commissionSeances as CommissionSeanceInterface[]).sort(
                ExComissionSeance.sortCommissionSeancesByDate
            );
        }
    }

    public canGererRecevabilite(): boolean {
        const statutAsString: string = (this.statut != null) ? this.statut.toString() : '0';
        if (
            StatutValues.Expertises !== statutAsString
            && StatutValues.Valide !== statutAsString
            && StatutValues.NonRecevable !== statutAsString
        ) {
            return false;
        }

        return false === this.aideOpen;
    }

    public canAjuster(): boolean {
        const statutAsString: string = (this.statut != null) ? this.statut.toString() : '0';
        return (
            StatutValues.Expertises === statutAsString
            || statutAsString === StatutValues.Attente
            || statutAsString === StatutValues.Complementaire
        );
    }

    public canRouvrir(): boolean {
        const statutAsString: string = (this.statut != null) ? this.statut.toString() : '0';
        return (
            statutAsString === StatutValues.Valide
            || statutAsString === StatutValues.NonRecevable
            || statutAsString === StatutValues.Expertises
            || (statutAsString === StatutValues.EnCours && !this.aideOpen)
        );
    }

    public canPasserRecevable(): boolean {
        const statutAsString: string = (this.statut != null) ? this.statut.toString() : '0';
        return StatutValues.Expertises !== statutAsString && this.canGererRecevabilite();
    }

    public canPasserNonRecevable(): boolean {
        const statutAsString: string = (this.statut != null) ? this.statut.toString() : '0';
        return StatutValues.NonRecevable !== statutAsString && this.canGererRecevabilite();
    }

    public can(action: string): boolean {
        switch (action) {
            case 'gererRecevabilite':
                return this.canGererRecevabilite();
            case 'passerRecevable':
                return this.canPasserRecevable();
            case 'passerNonRecevable':
                return this.canPasserNonRecevable();
            case 'rouvrir':
                return this.canRouvrir();
            case 'ajustementDossier':
                return this.canAjuster();
            default:
                return false;
        }
    }

    public hasDecisionForCommissionSeance(cs: CommissionInterface | string): boolean {
        return (this.getDecisionForCommissionSeance(cs) !== undefined);
    }

    public getDecisionForCommissionSeance(cs: CommissionInterface | string): DecisionInterface | undefined {
        if (!this.decisions) {
            throw new Error(
                'décisions non initialisées'
            );
        }

        if (!(typeof cs === 'string')) {
            cs = cs['@id'];
        }

        return (this.decisions as DecisionInterface[]).find(
            (item) => {
                const csItem = item.commissionSeance;
                return csItem && (typeof csItem === 'string') ? csItem === cs : csItem['@id'] === cs;
            }
        );
    }

    public getLiensInteretsParType() {
        if (!this.lienInterets) {
            return [];
        }

        const groupedLienInterets = (this.lienInterets as LienInteretInterface[]).reduce(
            (acc, item: LienInteretInterface) => {
                const lib = item.fullname + ' - ' + item.raison;

                if (!acc[item.type]) {
                    acc[item.type] = {
                        type: item.type,
                        libelle: lib
                    };
                } else {
                    acc[item.type].libelle += '\n' + lib;
                }

                return acc;
            },
            {}
        );

        return Object.keys(groupedLienInterets).map(key => groupedLienInterets[key]);
    }

    public getLastDecision() {
        let lastDecision = null;
        if (this.decisions.length > 0) {
            this.decisions.forEach(decision => {
                if (lastDecision == null || new Date(decision.commissionSeance.datetimeDebut) > new Date(lastDecision.commissionSeance.datetimeDebut)) {
                    lastDecision = decision;
                }
            });
        }
        return lastDecision;
    }
}
